import type { Person } from '../types';

const image_path = '/images/people/';
const image_res = [512, 1024];
const image_res_avif = [853];

export const info_url = 'https://www.marcheingol.it/soggetto/';

export function usePersonDisplay() {
  function image_urls(id?: number | string | null, id_avif?: number | null) {
    if (id == null && id_avif == null) return image_path + 'empty.svg';
    if (id_avif != null) {
      return image_res_avif
        .map((res) => image_path + res + '/' + id_avif + '.avif ' + res + 'w')
        .join(',');
    }
    return image_res
      .map((res) => image_path + res + '/' + id + '.jpg ' + res + 'w')
      .join(',');
  }

  function image_url(id?: number | string | null, id_avif?: number | null) {
    if (id == null && id_avif == null) return image_path + 'empty.svg';
    if (id_avif != null) return image_path + image_res_avif[0] + '/' + id_avif + '.avif';
    return image_path + image_res[0] + '/' + id + '.jpg';
  }

  function person_name(person?: Person | null) {
    if (person == null) return '';
    return person.last_name + ' ' + person.first_name;
  }

  return { image_urls, image_url, person_name };
}
